<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { dataManager, type ImportantDate } from '@/dataManager'
import VueFeather from 'vue-feather';

const emit = defineEmits<{
  (e: 'backButton', backUrl: string|null): void
}>()

const router = useRouter()
const dm = dataManager.getInstance()

type ImportantDateForm = {
  date: string|null
  title: string|null
}

const importantDates = ref<ImportantDateForm[]>(initialDates())

const errorMessage = ref<string>('')

onMounted(() => {
  console.log("Configuration mounted")
  emit('backButton', 'back')
})

function removeDate(index: number): void {
  importantDates.value.splice(index, 1)
}

function initialDates(): ImportantDateForm[] {
  const importantDateForms: ImportantDateForm[] = []
  dm.getCurrentUserData().importantDates.forEach((importantDate) => {
    importantDateForms.push({
      date: importantDate.date.toISOString().split('T')[0],
      title: importantDate.title
    })
  })
  return importantDateForms
}

function save(): void {
  errorMessage.value = ''
  const toSaveImportantDates: ImportantDate[] = []

  for (let i=0; i < importantDates.value.length; i++) {
    const currentImportantDate = importantDates.value[i]
    if ( !currentImportantDate.title || !currentImportantDate.title.trim()) {
      errorMessage.value = 'El título es obligatorio'
      return
    }
    if (! currentImportantDate.date) {
      errorMessage.value = 'La fecha es obligatoria'
      return
    }
    const currentDate = new Date(currentImportantDate.date)
    if (isNaN(currentDate.getTime())) {
      errorMessage.value = 'La fecha no es válida'
      return
    }
    toSaveImportantDates.push({
      date: currentDate,
      title: currentImportantDate.title.trim()
    })
  }
  dm.saveImportantDates(toSaveImportantDates)
  router.push('/')
}
</script>

<template>
  <h2>Configuración</h2>

  <h3><VueFeather type="calendar"/> Fechas señaladas</h3>
  <p>Las fechas señaladas aparecerán en tus gráficas para destacar su influencia en tu evolución.</p>

  <div v-for="(importantDate, index) in importantDates" class="important-date-line">
    <label>
      <span class="form-line"><input type="date" v-model="importantDate.date" />
        <button class="remove-date secondary" @click="removeDate(index)">
          <VueFeather type="minus"/>
          Quitar</button></span>
      <input type="text" maxlength="15" v-model="importantDate.title" placeholder=""/>
    </label>
  </div>
  <button @click="importantDates.push({title: '', date: null})" class="add-date">
    <VueFeather type="plus"/>
    Añadir fecha
  </button>
  <p class="error" v-if="errorMessage">{{ errorMessage }}</p>
  <button @click="save" class="button">Guardar</button>
</template>

<style scoped>
h2, p {
  text-align: center;
}

label {
  display: block;
  margin-top: 0;
  margin-bottom: 10px;
  background-color: transparent;

  --input-field-width: 350px;
  width: var(--input-field-width);
  max-width: 100%;

  p {
    font-size: 10pt;
    margin-left: 10px;
    margin-bottom: -8px;
    position: relative;
    text-align: left;
  }
  span {
    background-color: white;
    padding-left: 3px;
    padding-right: 3px;
  }

  input {
    z-index: -1;
    font-size: 12pt;
    width: var(--input-field-width);
    max-width: 100%;
    height: 40px;
    border: 1px solid #ff6800;
    border-radius: 5px;
    margin-bottom: 2px;
    padding: 10px;
    font-family: var(--input-font);
    &::placeholder {
      opacity: 0.5;
    }
  }
}

button.add-date {
  margin-top: 0;
}

.important-date-line {
  margin-bottom: 5px;

  label {
    margin-bottom: 0;
  }
}

.form-line {
  display: flex;
  white-space: nowrap;
  align-items: center;
  padding: 0;
  gap: 5px;

  input {
    flex-grow: 1;
    width: auto;
    z-index: 0;
  }

  button {
    margin: 0
  }
}
</style>
